import { faEnvelope, faStar } from '@awesome.me/kit-a6e51d954f/icons/classic/regular';

import ReviewsReceived from './components/ReviewsReceived';
import ReviewsRequested from './components/ReviewsRequested';

export const ERROR_TITLES = {
  reviewRequest: {
    create: 'Unable to send review request.',
  },
};

export const SUCCESS_MESSAGES = {
  reviewRequest: {
    create: 'Review request sent.',
  },
};

export const TABS_CONFIG = [
  {
    component: ReviewsReceived,
    icon: faStar,
    label: 'Reviews',
    value: 'reviewsReceived',
  },
  {
    component: ReviewsRequested,
    icon: faEnvelope,
    label: 'Requests',
    value: 'reviewsRequested',
  },
];
